import styled from 'styled-components';

const ToastProvider = styled.div``;

export { ToastProvider };
